import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { mediaMaxWidth } from 'common/styles/breakpoints';
import {
    HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS,
    FONT_PROPERTIES,
    BORDER_PROPERTIES,
    FOCUS_CSS,
} from 'common/components/TouchpointEditor/components/TouchpointContainer';

export const AttendeeSessionsListBlockContentContainer = styled.div`
    max-width: 770px;
    margin: 0 auto;
    width: 100%;
    display: grid;
    row-gap: 2rem;

    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

const disabledCss = css`
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
`;

const enabledCss = css`
    &:hover {
        background-color: ${(props) => props.$backgroundColorHover};
        color: ${(props) => props.$fontColorHover};
        border-color: ${(props) => props.$borderColorHover};
    }

    &:focus {
        outline-style: auto;
    }
`;

export const SessionButton = styled(Link)`
    display: inline-block;
    padding: 0.75rem 1.5rem;
    background-color: ${(props) => props.$backgroundColor};
    white-space: nowrap;
    text-align: center;
    border-style: solid;

    ${FONT_PROPERTIES}
    ${BORDER_PROPERTIES}
    ${FOCUS_CSS}

    ${mediaMaxWidth.medium`
        word-break: break-word;
        white-space: initial;
    `}

    ${(props) => (props.disabled ? disabledCss : enabledCss)}
`;
